

// export const baseUrl = `https://book-store-an5l.onrender.com/api/v1/`
export const baseUrl = `https://bookstore-api.codecraftsportfolio.online/api/v1/`
// export const baseUrl = `http://localhost:8080/api/v1/`   
